import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOutboundsUnitsConfirmResponse } from '~/types/delivery-agency.types';

const usePostOutboundsUnits = () => {
  const { runAsync } = useAsyncHandler();

  const postOutboundsUnits = useAPI<unknown, TypePostOutboundsUnitsConfirmResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_OUTBOUND_UNITS_CONFIRM,
    method: 'post',
  });

  const requestOutboundUnitsConfirm = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypePostOutboundsUnitsConfirmResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) => {
    return runAsync(() => postOutboundsUnits({}), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestOutboundUnitsConfirm };
};

export default usePostOutboundsUnits;
